import {isEmpty} from 'lodash';
import {DocumentBaseGroup, DocumentField} from '@/engine';

const EXCLUDED_FIELD_TYPES: DocumentField['type'][] = ['spacer', 'divider', 'hidden'];

export const isGroupVisuallyHidden = ({hidden, fields}: DocumentBaseGroup) =>
  hidden || isEmpty(fields.filter(field => field.visible && !EXCLUDED_FIELD_TYPES.includes(field.type)));
